
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface SEOData {
  title?: string;
  description?: string;
  keywords?: string;
  image_url?: string;
  canonical_url?: string;
  og_type?: string;
  og_title?: string;
  og_description?: string;
  og_url?: string;
  og_image?: string;
  og_image_alt?: string;
  og_site_name?: string;
  author?: string;
  copyright?: string;
}

export const useSEO = (pagePath: string) => {
  const [seoData, setSeoData] = useState<SEOData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSEOData = async () => {
      try {
        const { data, error } = await supabase
          .from('seo_settings')
          .select('*')
          .eq('page_path', pagePath)
          .eq('is_active', true)
          .single();

        if (error) {
          console.log('No SEO configuration found for:', pagePath);
          setSeoData(null);
        } else {
          setSeoData(data);
        }
      } catch (error) {
        console.error('Error fetching SEO data:', error);
        setSeoData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchSEOData();
  }, [pagePath]);

  return { seoData, loading };
};
